import { useState, useEffect } from 'react'
import { useParams, useLocation, useNavigate } from 'react-router-dom'
import { usePileStore, INITIAL_STATE } from 'Store/Pile'
import { toast } from 'react-toastify'
import { shallow } from 'zustand/shallow'
import * as Yup from 'yup'

const ViewModel = () => {
  const validationSchema = Yup.object().shape({
    itemTitle: Yup.string().required('Required'),
    itemCode: Yup.string().not([0]).required('Required'),
    height: Yup.string().required('Required'),
    width: Yup.number().required('Required'),
    weight: Yup.number().required('Required'),
  })

  const navigate = useNavigate()
  const { id } = useParams()
  const location = useLocation()
  const isCreate = location.pathname.includes('create')

  const { selected, getOne, createPile, edit, clearState } = usePileStore(
    state => ({
      selected: state.selected,
      getOne: state.getOne,

      createPile: state.create,
      edit: state.edit,
      clearState: state.clearState,
    }),
    shallow
  )

  const [formState, setFormState] = useState(INITIAL_STATE)
  const [formError, setFormError] = useState<any>(
    Object.keys(INITIAL_STATE).reduce((acc, key) => ({ ...acc, [key]: false }), {})
  )
  const [isLoading, setIsLoading] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const fetchData = () => {
    if (!isCreate && id) {
      setIsLoading(true)
      getOne(id).then(({ data, success }) => {
        if (!success) {
          toast.error('เกิดข้อผิดพลาดในการดึงข้อมูล : ' + data)
        } else {
          setFormState(data)
          setIsLoading(false)
        }
      })
    }
  }

  const onChangeFormState = (name: string, value: any) => {
    setFormState(prev => ({ ...prev, [name]: value }))
  }

  const onCancel = () => {
    navigate(-1)
  }

  const onSubmit = () => {
    setIsSubmitting(true)

    validationSchema
      .validate(formState, { abortEarly: false })
      .then(() => {
        if (isCreate) {
          createPile(formState).then(({ success, data }) => {
            if (!success) {
              toast.error(data.message)
              setIsSubmitting(false)
            } else {
              toast.success('สร้างเสาเข็มสำเร็จ')
              navigate(-1)
            }
          })
        } else if (!isCreate && id) {
          const body: { [key: string]: any } = {}
          const editableFields = ['itemTitle', 'itemCode', 'height', 'width', 'weight']

          editableFields.forEach(field => {
            // @ts-ignore
            if (formState[field] !== selected[field]) {
              // @ts-ignore
              body[field] = formState[field]
            }
          })

          if (Object.keys(body).length === 0) {
            setIsSubmitting(false)
            return
          }

          edit(Number(id), body).then(({ success, data }) => {
            if (!success) {
              toast.error('แก้ไขเสาเข็มไม่สำเร็จ : ' + data)
              setIsSubmitting(false)
            } else {
              setIsSubmitting(false)
              toast.success('แก้ไขเสาเข็มสำเร็จ')
              fetchData()
            }
          })
        }
      })
      .catch(err => {
        const errors: { [key: string]: any } = {}
        err.inner.forEach((e: any) => {
          errors[e.path] = e.message
        })
        toast.error('กรุณากรอกข้อมูลให้ครบถ้วน')
        setFormError(errors)
        setIsSubmitting(false)
      })
  }

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line
  }, [id])

  useEffect(() => {
    return () => {
      clearState()
    }
    // eslint-disable-next-line
  }, [])

  return {
    isLoading,
    isSubmitting,
    isCreate,
    formState,
    formError,
    onChangeFormState,
    onSubmit,
    onCancel,
  }
}

export default ViewModel
